import React, {FC} from 'react'
import {MenuInner} from './MenuInner'

const Breadcrumbs: FC = () => {
  const windowLocation: any = window.location.pathname.split('/')
  return (
    <>
    {windowLocation.length > 1 &&
      <div className='breadcrumb-2'>
        {windowLocation[1]}<span className="bullet w-5px h-2px mb-1"></span>{windowLocation[2]}
      </div>
    }
    </>
  )
}

export {Breadcrumbs}
